import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { popUpMenuChange, 
        popUpMessageChange,
        selectedCardsGroupsChange,
        setAddProgress } from '../../actions/index'

import Icon from '@mdi/react';
import { mdiChartBoxPlusOutline } from '@mdi/js';

import { _ } from '../../functions/translator'
import { showMessage } from '../../functions/popUpMessage';

class AddProgressButton extends React.Component{
          
    handleClick = () => {
        if (this.props.userRole.add_progress_update) {
            this.props.setAddProgress({ show: true, cardsGroupIds: this.props.cardsGroupIds })
        } else {
            showMessage(this.props, _('No tienes permisos para agregar avances') + '.');
        }
        this.props.popUpMenuChange({ show: false })
        this.props.selectedCardsGroupsChange([])
    }

    render(){   
       
        return (
            <div>
                <div className="popup-menu-button card-color" ref={ref => this.button = ref} onClick={this.handleClick}>
                    <div className='d-inline-flex'>
                        <Icon path={ mdiChartBoxPlusOutline } size='30px' color='white' style={{marginTop: 10, marginLeft: 13, marginRight: 10}}/>
                        <p>{ _('Agregar Avance') }</p>
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
        userRole : state.userRole,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        popUpMenuChange : popUpMenuChange,
        popUpMessageChange : popUpMessageChange,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        setAddProgress : setAddProgress
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(AddProgressButton)